export default Object.freeze({
  Header: 1,
  Url: 2,
  FormData: 3,
  BodyJson: 4,
  XWwwFormUrlEncoded: 5,
  Authorization: 6,
  BodyText: 7,
  FormFileData: 8,
});
